import styled, { css } from 'styled-components';

/**
 * Layout only.
 *
 * Nothing here sets a font size, a padding or a height on a table row, cell or header: the rows are
 * the application's `ui/table/Table`, and the moment this file overrides its metrics the monitor
 * stops looking like every other list in the app.
 */
export const PanelRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1.4fr;
  gap: 16px;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

export const Toolbar = styled.div(
  ({ theme: { palette } }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 12px 16px;
    background-color: ${palette.common.white};
    border: 1px solid ${palette.chart.grid};
    border-radius: 8px;
  `,
);

export const SelectionCount = styled.span(
  ({ theme: { palette } }) => css`
    color: ${palette.text.primary};
  `,
);

export const ToolbarSpacer = styled.div`
  flex-grow: 1;
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export const FilterField = styled.div`
  min-width: 200px;
`;

/** The free-text search carries a long placeholder; give it room so it is not cut mid-word. */
export const SearchField = styled(FilterField)`
  min-width: 320px;
  flex: 1;
  max-width: 480px;
`;

export const RowActions = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;

  & > * {
    flex-shrink: 0;
  }
`;

/**
 * The order's payload in the details panel. A monospace block is the content itself — an operator
 * compares it character by character with a protocol capture — not a typography override.
 */
export const PayloadBlock = styled.pre(
  ({ theme: { palette } }) => css`
    margin: 0;
    padding: 12px;
    background-color: ${palette.grey[100]};
    border: 1px solid ${palette.chart.grid};
    border-radius: 8px;
    font-family: 'JetBrains Mono', ui-monospace, Menlo, monospace;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: 320px;
    overflow-y: auto;
  `,
);

export const ReadOnlyNote = styled.span(
  ({ theme: { palette } }) => css`
    color: ${palette.info.main};
  `,
);
